import React from 'react'

import * as S from './styles'

export function CertificationsShimmer() {
  return (
    <>
      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>

      <div>
        <S.ShimmerCertification />
      </div>
      <div>
        <S.ShimmerCertification />
      </div>
    </>
  )
}
